<template>
    <v-container style="padding-top: 70px;">
        <div v-if="showcargando == true" id="cargando" wire:loading
             class="fixed top-0 left-0 right-0 bottom-0 w-full h-screen z-50 overflow-hidden bg-gray-700 opacity-75 flex flex-col items-center justify-center ">
            <div class=" loader ease-linear rounded-full border-4 border-t-4 h-12 w-12 mb-4 "></div>
            <h2 class="text-center text-white text-xl font-semibold">Cargando...</h2>
            <p class="w-1/3 text-center text-white">
                Esto puede tardar unos segundos, no cierre esta página.
            </p>
        </div>
        <v-row class="ma-1 ">
            <v-card width="100%" class="mx-2">
                <Menu></Menu>
            </v-card>
        </v-row>
        <v-row>
            <v-col cols="12" md="4">
                <v-card flat class="text-xs-center ma-1" width="100%">
                    <v-card-title class=" primary">
                        <span class="card-title-text" style="color: white;">RC Médico</span>
                    </v-card-title>
                    <v-card-text>
                        <CajaBusqueda @Respuesta="Buscar" Tipo="RCMedico" @limpia="Limpiar"></CajaBusqueda>
                    </v-card-text>
                </v-card>
            </v-col>
            <v-col cols="12" md="8">
                <v-card class="text-xs-center ma-1" v-if="ver">
                    <v-card-title class=" primary">
                        <span class="card-title-text" style="color: white;">Radiografía</span>
                    </v-card-title>
                    <v-card-text>
                        
                        <vs-list v-for="item in listado">
                            <vs-list-item v-if="item.nivel == 1" :title="item.texto" subtitle="" style="font-size: 14px !important">
                                <v-btn v-if="item.total > 0 && item.procedimiento != ''" color="success" @click="Ver(item)" dark>{{item.total}}</v-btn>
                                <v-btn v-if="item.total == 0 && item.procedimiento != ''">{{item.total}}</v-btn>
                                <span v-else></span>
                            </vs-list-item>
                            <vs-list-item v-if="item.nivel == 2" :title="item.texto" subtitle="" class="pl-8">
                                <v-btn v-if="item.total > 0 && item.procedimiento != ''" color="success" @click="Ver(item)" dark>{{item.total}}</v-btn>
                                <v-btn v-if="item.total == 0 && item.procedimiento != ''">{{item.total}}</v-btn>
                                <span v-else></span>
                            </vs-list-item>
                            <vs-list-item v-if="item.nivel == 3" :title="item.texto" subtitle="" class="pl-12">
                                <v-btn v-if="item.total > 0 && item.procedimiento != ''" color="success" @click="Ver(item)" dark>{{item.total}}</v-btn>
                                <v-btn v-if="item.total == 0 && item.procedimiento != ''">{{item.total}}</v-btn>
                                <span v-else></span>
                            </vs-list-item>
                            <vs-list-item v-if="item.nivel == 4" :title="item.texto" subtitle="" class="pl-16">
                                <v-btn v-if="item.total > 0 && item.procedimiento != ''" color="success" @click="Ver(item)" dark>{{item.total}}</v-btn>
                                <v-btn v-if="item.total == 0 && item.procedimiento != ''">{{item.total}}</v-btn>
                                <span v-else></span>
                            </vs-list-item>
                        </vs-list>
                    </v-card-text>
                </v-card>
                <v-card class="text-xs-center ma-1" v-if="ver == false">
                    <v-card-title class=" primary">
                        <span class="card-title-text" style="color: white;">Detalle</span>
                    </v-card-title>
                    <v-card-text>
                        <v-row>
                            <v-col clos="12" md="12">
                                <v-row justify="center">
                                    <v-btn class="ma-2" color="error" title="Regresar" @click="Regresar()">
                                        <span style='color: white;'>Regresar</span>
                                    </v-btn>
                                    <v-btn class="ma-2" title="Descargar" 
                                           :loading="loadingB"
                                            :disabled="loadingB"
                                           color="primary" @click="Descargar()">
                                        <v-icon left>
                                            mdi-file-excel-outline
                                        </v-icon>
                                        <template v-slot:loader>
                                            <span class="custom-loader">
                                                <v-icon light>mdi-cached</v-icon>
                                            </span>
                                        </template>
                                        Descargar
                                    </v-btn>
                                </v-row>

                            </v-col>
                            <v-col cols="12" md="12" class="ma-2">
                                <br />
                                <DataTable :url="url" :columns="head" :formatterActions="formatterActions"
                                           dom="<'row'<'col-sm-6'l><'col-sm-6 align-content:left'f>><'row'<'col-sm-12'tr >><'row'<'col-sm-6 text-center'i><'col-sm-6'p>>"
                                           :params="displayInputs" :order="[]" @apiDT="apiDT = $event">
                                </DataTable>
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>
<script>
    import { mapGetters, mapState, mapMutations } from 'vuex';
    import Menu from '@/components/pages/operacion/MenuEstadisticas/Menu.vue';
    import General from "@/services/Operacion/Operacion.service.js";
    import CajaBusqueda from '@/components/pages/operacion/Estadistica/CajaBusqueda.vue';
    import DataTable from "@/components/pages/DataTableNet/DataTable";
    import Archivos from '@/services/Archivos/Archivos.service.js';
    import SerBusqueda from '@/services/Busqueda/Busqueda.service.js';
    import MetodosGenerales from "@/utils/metodosgenerales.vue.js";
    import { read, utils, writeFileXLSX } from 'xlsx';

    export default {
        title() {
            return this.$route.meta.title
        },
        components: {
            Menu,
            DataTable,
            CajaBusqueda,
        },
        data() {
            return {
                loadingB: false,
                loader: null,
                showcargando: true,
                parametro: {},
                listado: [],
                ver: true,
                displayInputs: {},
                url: "Operacion/ObtenerDetalle",
                head: [
                    { name: "Reporte", data: "Reporte", title: "Reporte", formatter: [this, "detalleReporte"], },
                    { name: "Fecha reporte", data: "Fecha reporte", title: "Fecha Reporte" },
                    { name: "Fecha siniestro", data: "Fecha siniestro", title: "Fecha Siniestro" },
                    { name: "Numsiniestro", data: "Numsiniestro", title: "Num. de siniestro" },
                    { name: "Póliza", data: "Póliza", title: "Póliza" },
                    { name: "Asegurado", data: "Asegurado", title: "Asegurado" },
                    { name: "Ciudad", data: "Ciudad", title: "Ciudad" },
                    { name: "Abogado", data: "Abogado", title: "Abogado" },
                    { name: "Cliente", data: "Cliente", title: "Cliente" },
                    { name: "Instancia", data: "Instancia", title: "Instancia" },
                ],
                formatterActions: [
                    { click: [this, "BuscarReporte"] },
                ],
                nombreArchivo: 'RCMedico ',
                parametroproc: '',
                nombrelistado: '',
            }
        },
        methods: {
            Limpiar() {
                this.listado = [];
                if (this.apiDT != null)
                    this.apiDT.clear().draw();
                this.ver = true;
            },
            detalleReporte(datos) {
                if ((datos.aiclave == 1 || datos.aiclave == 23 || datos.aiclave == 24 || datos.aiclave == 5)) {
                    return `<div class="ml-3"><button data-action="0" data-params="${datos.nrreporte}" class="dt-formatterAction ma-1 reporteindice">${datos.nrreporte}-${datos.svindice}</span></button></div>`;
                } else {
                    return `<span>${datos.nrreporte}-${datos.svindice}</span>`;
                }
            },
            async BuscarReporte(params, item, fila) {
                let reporte = {
                    nrreporte: item.nrreporte,
                    svindice: item.svindice,
                    aiclave: item.aiclave,
                    svfhconclusion: item.svfhconclusion
                };
                var ver = 0;
                let formData = new FormData();
                formData.append("nrreporte", item.nrreporte);
                formData.append("svindice", item.svindice);
                await SerBusqueda.ObtenerValidacion(this, formData).then(data => {
                    ver = data;
                });
                let url = '';

                if (ver == 0) {
                    url = this.$router.resolve({ name: `${"DatosIncompletos"}` });
                }
                else {
                    //let routerName = MetodosGenerales.obtenerRouterName(item.aiclave.toString());
                    await MetodosGenerales.guardarEnSesionInfoReporte(reporte, 'reporte');
                    //url = this.$router.resolve({ name: `${routerName}` });
                    let asistenciaurl = await MetodosGenerales.ObtenerURL(reporte);
                    url = this.$router.resolve({ path: asistenciaurl + '/ReporteDetalle' });
                }
                window.open(url.href, '_blank');
            },
            async Descargar() {
                this.loadingB = true;
                this.displayInputs.procedimiento = this.parametroproc + '_';
                let formdata = new FormData();
                formdata.append("data", JSON.stringify(this.displayInputs));
                await General.ObtenerDetalleExcel(this, formdata).then(data => {
                    if (data.success == true) {
                        let aux_listado = data.data;
                        for (let i in aux_listado) {
                            for (const [key, value] of Object.entries(aux_listado[i])) {
                                if (typeof value === "object") {
                                    aux_listado[i][key] = "";
                                } else {
                                    aux_listado[i][key] = value.toString();
                                }
                            }
                        }

                       
                        MetodosGenerales.exportToExcel(aux_listado, this.nombreArchivo + this.nombrelistado + ".xlsx", false, false);


                        var formData = new FormData();
                        formData.append("lasitio", 'Prusia+');
                        formData.append("lomodulo", 'EstadisticaGeneral');
                        formData.append("laaccion", "Descargar Archivo excel");
                        formData.append("lacaracteristicas", 'Estadistica RCMedico ');
                        formData.append("lanombre", this.nombreArchivo + ".xlsx");
                        formData.append("ladestinatario", " ");
                        Archivos.AlmacenarVisitas(formData).then(data => {
                        });
                       
                    }
                    else {
                        this.$swal(
                            "Atención",
                            "Ocurrió un error, al descargar el archivo, intente nuevamente más tarde, si el problema persiste, pónganse en contacto con el área de soporte.",
                            "info"
                        );
                    }
                    this.loadingB = false;
                });
            },
            Regresar() {
                this.ver = true;
            },
            Ver(item) {
                this.nombrelistado = item.texto;
                this.parametroproc = item.procedimiento;
                this.displayInputs.clclave = this.parametro.aseguradora != null && this.parametro.aseguradora != '' ? this.parametro.aseguradora.clclave : null;
                this.displayInputs.flclave = this.parametro.flotilla != '' ? this.parametro.flotilla.flclave : null;
                this.displayInputs.fecini = this.parametro.fecha != '' ? this.parametro.fecha : null;
                this.displayInputs.fecfin = this.parametro.fechafin != '' ? this.parametro.fechafin : null;
                this.displayInputs.esclave = this.parametro.estado != '' ? this.parametro.estado.esclave : null;
                this.displayInputs.geclave = this.parametro.gerencia == null || this.parametro.gerencia == '' ? null : this.parametro.gerencia.geclave;
                this.displayInputs.suclave = this.parametro.supervisoria != '' ? this.parametro.supervisoria.suclave : null;
                this.displayInputs.prclave = this.parametro.abogado != '' ? this.parametro.abogado.prclave : null;
                this.displayInputs.usperfil = this.parametro.perfil;
                this.displayInputs.procedimiento = item.procedimiento;
                this.displayInputs.seleccion = item.orden;


                this.ver = false;

            },
            Buscar(items, parametro) {

                this.listado = items;
                this.parametro = parametro;
                this.ver = true;
            }
        },
        computed: {
            ...mapState(['permission', 'domain']),
            ...mapGetters(['getUser', 'THEME_STATE'])
        },
        mounted() {
            this.showcargando = false;
        },
        async beforeMount() {
            await MetodosGenerales.verificarPermisoSolo(this.domain.domainNameForApi, "VerificarPermiso", '132').then(response => {
                if (response.data.length > 0) {
                } else {
                    this.$router.push({ name: `NoAutorizado` }).catch(error => error);
                }

            });
        }
    }
</script>
<style scoped>
    .Color {
        background-color: #eee;
    }

    .Table {
        display: table;
    }

    .Heading {
        display: table-row;
        font-weight: bold;
        text-align: center;
    }

    .Row {
        display: table-row;
    }

    .Cell {
        display: table-cell;
        padding-left: 5px;
        padding-right: 5px;
        padding-top: 10px;
        padding-bottom: 10px;
        width: 100%;
    }

    .Row:hover {
        background: #CCC
    }
    .custom-loader {
        animation: loader 1s infinite;
        display: flex;
    }

    @-moz-keyframes loader {
        from {
            transform: rotate(0);
        }

        to {
            transform: rotate(360deg);
        }
    }

    @-webkit-keyframes loader {
        from {
            transform: rotate(0);
        }

        to {
            transform: rotate(360deg);
        }
    }

    @-o-keyframes loader {
        from {
            transform: rotate(0);
        }

        to {
            transform: rotate(360deg);
        }
    }

    @keyframes loader {
        from {
            transform: rotate(0);
        }

        to {
            transform: rotate(360deg);
        }
    }
</style>